import * as yup from 'yup';

export const maintenanceSchema = yup.object({
  comment: yup.string().required(),
});
